import script from "./UserReferals.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserReferals.vue?vue&type=script&setup=true&lang=ts"

import "./UserReferals.vue?vue&type=style&index=0&id=7f88aa66&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f88aa66"]])

export default __exports__